// extracted by mini-css-extract-plugin
export default {"timeDisplay":"SlvhVl"};